function readValue(source, keys) {
  for (const key of keys) {
    if (source && Object.prototype.hasOwnProperty.call(source, key) && source[key] !== undefined && source[key] !== null) {
      return source[key];
    }
  }
  return undefined;
}

function getString(value) {
  if (value === undefined || value === null) return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "number") return String(value).trim();
  return String(value).trim();
}

function isKnownStatus(value, accepted) {
  const status = getString(value).toUpperCase();
  return status !== "" && accepted.has(status);
}

export function computeProfileCompletion(user = {}) {
  const rules = [];

  const identityValue = getString(readValue(user, ["display_name", "displayName", "name", "username"]));
  if (identityValue) {
    rules.push({ id: "identity", complete: true });
  }

  const emailValue = getString(readValue(user, ["email", "email_address", "primary_email"]));
  const emailVerified = readValue(user, ["email_verified", "emailVerified", "email_verification_state", "emailVerificationState"]);
  if (emailValue) {
    const verified = ["VERIFIED", "TRUE", "YES", "CONFIRMED"].includes(getString(emailVerified).toUpperCase());
    rules.push({ id: "email", complete: verified });
  }

  const phoneValue = getString(readValue(user, ["phone", "phone_number", "phoneNumber", "mobile"]));
  const phoneVerified = readValue(user, ["phone_verified", "phoneVerified", "phone_verification_state", "phoneVerificationState"]);
  if (phoneValue) {
    const verified = ["VERIFIED", "TRUE", "YES", "CONFIRMED"].includes(getString(phoneVerified).toUpperCase());
    rules.push({ id: "phone", complete: verified });
  }

  const notificationValue = readValue(user, ["notification_status", "notificationStatus", "notifications", "notification_account"]);
  if (notificationValue !== undefined && notificationValue !== null) {
    const statusValue = typeof notificationValue === "string" ? notificationValue : getString(readValue(notificationValue, ["status", "state", "lifecycle_state", "lifecycleState"]));
    const accepted = new Set(["READY", "ACTIVE", "VERIFIED", "CONFIRMED"]);
    rules.push({ id: "notifications", complete: isKnownStatus(statusValue, accepted) });
  }

  const total = rules.length;
  const completed = rules.filter((rule) => rule.complete).length;
  const percent = total === 0 ? 0 : Math.round((completed / total) * 100);
  const label = total === 0 ? "0 of 0 complete" : `${completed} of ${total} complete`;

  return {
    completed,
    total,
    percent,
    available: total > 0,
    label,
    summary: total === 0 ? "Profile details unavailable" : percent >= 100 ? "Profile complete" : percent >= 60 ? "Profile nearly complete" : "Profile needs attention",
  };
}

export function getProfileCompletionLabel(result) {
  if (!result || !result.available) return "Profile details unavailable";
  if (result.percent >= 100) return "Profile complete";
  if (result.percent >= 60) return "Profile nearly complete";
  return "Profile needs attention";
}
